/**
 * Карта с клиниками текущего города
 *
 * @param {Object} params
 * @param {String} params.map - имя карты
 * @param {String} params.disableCenterClinic - отключить центрирование выбранной клиники
 * @param {String} params.clinicsAddresses - адреса клиник
 * @param {String} params.firstCoordinates - координаты первой клиники
 * @param {String} params.adultsCoordinates - координаты клиник для взрослых
 * @param {String} params.familyCoordinates - координаты семейных клиник
 * @param {String} params.iconImagePath -путь до изображений
 * @param {String} params.iconImageHref - своё изображение иконки метки
 * @param {String} params.iconLayout - изображение метки
 * @param {Array} params.iconImageSize - размеры метки
 * @param {Array} params.iconImageOffset - смещение метки
 * @param {Array} params.iconImageOffsetCluster - смещение метки кластера
 * @param {String} params.iconImageFamily - изображение семейной клиники
 * @param {String} params.iconImageFamilyHover - изображение выбранной семейной клиники
 * @param {String} params.iconImageMan - изображение клиники для взрослых
 * @param {String} params.iconImageManHover - изображение выбранной клиники для взрослых
 * @param {String} params.iconImageCluster - изображение кластера
 * @param {Number} params.zoomMap - увеличение карты
 * @param {String} params.showClinic - отображение данной клиники
 * @param {String} params.mapClinicCenter - центр клиники на карте
 * @param {String} params.closeClinic - кнопка закрытия клиники
 * @param {Number} params.gridSize -размер ячейки кластера
 * @param {Number} params.textSize - размер текста кластера
 */
$.fn.mapClinics = function (params) {
    const $self = $(this);
    const $mapClinicCenter = params.mapClinicCenter;
    const $closeClinic = params.closeClinic;
    const map = params.map;
    const disableCenterClinic = !!$self.attr(params.disableCenterClinic);
    const clinicsAddresses = JSON.parse($self.attr(params.clinicsAddresses));
    const firstCoordinates = JSON.parse($self.attr(params.firstCoordinates));
    const familyCoordinates = JSON.parse($self.attr(params.familyCoordinates));
    const adultsCoordinates = JSON.parse($self.attr(params.adultsCoordinates));
    const iconImagePath = $self.attr(params.iconImagePath);
    const iconImageHref = params.iconImageHref;
    const iconLayout = params.iconLayout;
    const iconImageSize = params.iconImageSize;
    const iconImageOffset = params.iconImageOffset;
    const iconImageOffsetCluster = params.iconImageOffsetCluster;
    const iconImageFamily = params.iconImageFamily;
    const iconImageFamilyHover = params.iconImageFamilyHover;
    const iconImageMan = params.iconImageMan;
    const iconImageManHover = params.iconImageManHover;
    const iconImageCluster = params.iconImageCluster;
    const zoomMap = params.zoomMap;
    const showClinic = params.showClinic;
    const gridSize = params.gridSize;
    const textSize = params.textSize;
    const centerMapClinicsCoordinates = Object.values(firstCoordinates);

    if (iconImagePath) {
        ymaps.ready(initMapClinics);
    }

    /**
     * Отображение карты
     */
    function initMapClinics() {
        let myMap = new ymaps.Map(map, {
            center: centerMapClinicsCoordinates,
            zoom: zoomMap,
            controls: [],
        }),
            MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="map-popover">' +
                '<div class="map-popover__inner">' +
                '$[[options.contentLayout observeSize minWidth=243 maxWidth=243]]' +
                '</div>' +
                '</div>', {
                    /**
                     * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                     * @function
                     * @name build
                     */
                    build: function () {
                        this.constructor.superclass.build.call(this);

                        this._$element = $('.popover', this.getParentElement());
                        this.applyElementOffset();
                    },

                    /**
                     * Удаляет содержимое макета из DOM.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                     * @function
                     * @name clear
                     */
                    clear: function () {
                        this._$element.find('.close')
                            .off('click');
                        this.constructor.superclass.clear.call(this);
                    },

                    /**
                     * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                     * @function
                     * @name onSublayoutSizeChange
                     */
                    onSublayoutSizeChange: function () {
                        MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
                        if(!this._isElement(this._$element)) {
                            return;
                        }

                        this.applyElementOffset();

                        this.events.fire('shapechange');
                    },

                    /**
                     * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                     * @function
                     * @name applyElementOffset
                     */
                    applyElementOffset: function () {
                        this._$element.css({
                            left: -(this._$element[0].offsetWidth / 2),
                            top: -(this._$element[0].offsetHeight)
                        });
                    },

                    /**
                     * Используется для автопозиционирования (balloonAutoPan).
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                     * @function
                     * @name getClientBounds
                     * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                     */
                    getShape: function () {
                        if(!this._isElement(this._$element)) {
                            return MyBalloonLayout.superclass.getShape.call(this);
                        }

                        var position = this._$element.position();
                        return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                            [position.left, position.top], [
                                position.left + this._$element[0].offsetWidth,
                                position.top + this._$element[0].offsetHeight
                            ]
                        ]));
                    },

                    /**
                     * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                     * @function
                     * @private
                     * @name _isElement
                     * @param {jQuery} [element] Элемент.
                     * @returns {Boolean} Флаг наличия.
                     */
                    _isElement: function (element) {
                        return element && element[0];
                    }
                });

        myMap.behaviors.disable('scrollZoom');
        let ctrlKey = false;
        let ctrlMessVisible = false;
        let timer;
        let $notation = $self.find($('.js-map-container')).closest('.map-wrapper').find('.scroll-notation');

        //Создадим пользовательский макет ползунка масштаба.
        let zoomLayout = ymaps.templateLayoutFactory.createClass('<div class="btn-zoom-wrapper">' +
            '<div id="zoom-in" class="btn zoom-in"><svg class="i-plus"><use xlink:href="/images/sprite.svg#ic_plus"></use></svg></div>' +
            '<div id="zoom-out" class="btn zoom-out"><svg class="i-minus"><use xlink:href="/images/sprite.svg#ic_minus"></use></svg></div>' +
            '</div>', {

            // Переопределяем методы макета, чтобы выполнять дополнительные действия
            // при построении и очистке макета.
            build: function () {
                // Вызываем родительский метод build.
                zoomLayout.superclass.build.call(this);

                // Привязываем функции-обработчики к контексту и сохраняем ссылки
                // на них, чтобы потом отписаться от событий.
                this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                // Начинаем слушать клики на кнопках макета.
                $self.find($('#zoom-in')).on('click', this.zoomInCallback);
                $self.find($('#zoom-out')).on('click', this.zoomOutCallback);
            },

            clear: function () {
                // Снимаем обработчики кликов.
                $self.find($('#zoom-in')).off('click', this.zoomInCallback);
                $self.find($('#zoom-out')).off('click', this.zoomOutCallback);

                // Вызываем родительский метод clear.
                zoomLayout.superclass.clear.call(this);
            },

            zoomIn: function () {
                let map = this.getData().control.getMap();
                map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
            },

            zoomOut: function () {
                let map = this.getData().control.getMap();
                map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
            }
        });
        let zoomControl = new ymaps.control.ZoomControl({options: {layout: zoomLayout}});
        myMap.controls.add(zoomControl, {position: {right: '24px', top: '264px'}});

        // Создаём макет содержимого.
        let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="map-clusterer">$[properties.iconContent]</div>'
        );

        //создание кластера
        let clusterer = new ymaps.Clusterer({
            clusterIcons: [
                {
                    href: iconImagePath + iconImageCluster,
                    size: iconImageSize,
                    offset: iconImageOffsetCluster
                }],
            gridSize: gridSize,
            textSize: textSize,
            clusterDisableClickZoom: false,
            maxZoom: zoomMap,
            clusterIconContentLayout: MyIconContentLayout,
        });


        let datafamilyCoordinates = familyCoordinates;
        let dataadultsCoordinates = adultsCoordinates;

        datafamilyCoordinates = window.convertObjToArr(datafamilyCoordinates);
        dataadultsCoordinates = window.convertObjToArr(dataadultsCoordinates);

        let clinicsCoordinatesObj = [];

        clinicsCoordinatesObj = window.merge(clinicsCoordinatesObj, datafamilyCoordinates);
        clinicsCoordinatesObj = window.merge(clinicsCoordinatesObj, dataadultsCoordinates);

        const prepareCoordinates = function (dataCoordinates, type) {

            let geoObjects = [];

            let index = 0;
            dataCoordinates.forEach(function (item) {
                let iconHover = iconImagePath + iconImageFamilyHover;
                let icon = iconImagePath + iconImageFamily;

                let dataPlacemark = {};

                if (type === 'adults') {
                    iconHover = iconImagePath + iconImageManHover;
                    icon = iconImagePath + iconImageMan;
                    dataPlacemark.balloonShadow = false;
                }

                dataPlacemark.iconLayout = iconLayout;
                dataPlacemark.iconImageHref = icon;
                dataPlacemark.iconImageSize = iconImageSize;
                dataPlacemark.balloonCloseButton = false;
                dataPlacemark.iconImageOffset = iconImageOffset;
                dataPlacemark.hasBalloon = false;
                dataPlacemark.balloonLayout = MyBalloonLayout;


                let findedClinicId = findClinicIdByCoord(clinicsCoordinatesObj, item);
                geoObjects[index] = new ymaps.Placemark(item, {}, dataPlacemark);
                //смена иконки по наведению на точку
                geoObjects[index].events
                    .add('mouseenter', function (e) {
                        e.get('target').options.set(iconImageHref, iconHover);
                    })
                    .add('mouseleave', function (e) {
                        e.get('target').options.set(iconImageHref, icon);
                    })

                    .add('click', function (e) {
                        let clinicId = findClinicIdByCoord(clinicsCoordinatesObj, e.get('target').geometry._coordinates);
                        let $clinicItem = $('#clinic-id-'+ clinicId);
                        let isOpenClinik = $clinicItem.hasClass('open')
                        let isOpenClinikSm = $clinicItem.hasClass('opened');
                        let clinikLinks = document.querySelectorAll('.clinic-card__link-map');
                        let $clinicList = $('.js-clinic-card');

                        //если уже окно открыто
                        if (isOpenClinikSm) {
                            return;
                        }

                        //если уже окно открыто
                        if (isOpenClinik){
                            return
                        }
                        $clinicList.each(function () {
                            $(this).removeClass('open')
                        })
                        //открывает окно с информацией о клинике
                        setTimeout(() => {
                            document.querySelector("#show-clinic-"+ clinicId).click();
                        }, 200);
                        if (disableCenterClinic) {
                            return
                        }
                    });

                index++;

            });

            return geoObjects;
        };

        let geoObjectsFamily = prepareCoordinates(datafamilyCoordinates, 'family');
        let geoObjectsAdults = prepareCoordinates(dataadultsCoordinates, 'adults');

        // Отслеживаем скролл мыши на карте, чтобы показывать уведомление
        myMap.events.add(['wheel', 'mousedown', 'touchmove'], function (e) {
            if (e.get('type') === 'wheel') {
                if (!ctrlKey) { // Ctrl не нажат, показываем уведомление
                    $notation.fadeIn(300);
                    ctrlMessVisible = true;
                    clearTimeout(timer); // Очищаем таймер, чтобы продолжать показывать уведомление
                    timer = setTimeout(function () {
                        $notation.fadeOut(300);
                        ctrlMessVisible = false;
                    }, 1500);
                } else { // Ctrl нажат, скрываем сообщение
                    $notation.fadeOut(100);
                }
            }
            if (e.get('type') === 'mousedown' && ctrlMessVisible) { // Скрываем уведомление при клике на карте
                $notation.fadeOut(100);
            }
        });

        // Обрабатываем нажатие на Ctrl
        $(document).keydown(function (e) {
            if (e.keyCode === 17 && !ctrlKey) { // Ctrl нажат: включаем масштабирование мышью
                ctrlKey = true;
                myMap.behaviors.enable('scrollZoom');
            }
        });
        $(document).keyup(function (e) { // Ctrl не нажат: выключаем масштабирование мышью
            if (e.keyCode === 17) {
                ctrlKey = false;
                myMap.behaviors.disable('scrollZoom');
            }
        });

        clusterer.add(geoObjectsFamily).add(geoObjectsAdults);
        myMap.geoObjects.add(clusterer);

        let countAllCoordinates = window.count(familyCoordinates) + window.count(adultsCoordinates);

        if (countAllCoordinates > 1) {
            myMap.setBounds(myMap.geoObjects.getBounds());

            $closeClinic.on('click', function () {
                myMap.setBounds(myMap.geoObjects.getBounds());
            });
        }

        if (countAllCoordinates > 1) {

            $mapClinicCenter.click(function () {

                myMap.setCenter([
                    $(this).data('coord-latitude'),
                    $(this).data('coord-longitude')
                ], zoomMap);

            });
        }
    }

    /**
     * Поиск клиники по координатам
     *
     * @param clinics
     * @param coordinates
     * @returns {number}
     */
    const findClinicIdByCoord = function (clinics, coordinates) {
        let clinicId = 0;

        clinics.forEach(function (item, index) {

            if (item[0] && item[1] && String(item[0]) === String(coordinates[0]) && String(item[1]) === String(coordinates[1])) {
                clinicId = index;
                return false;
            }
        });

        return clinicId;
    };

    return this;
};

// инициализация
const init = function () {
    $('#map-clinics-module').mapClinics({
        map: 'map-clinics',
        disableCenterClinic: 'data-disable-center-clinic',
        clinicsAddresses: 'data-clinics-addresses',
        firstCoordinates: 'data-first-coordinates',
        familyCoordinates: 'data-family-coordinates',
        adultsCoordinates: 'data-adults-coordinates',
        iconImagePath: 'data-icon-image-path',
        iconImageHref: 'iconImageHref',
        iconLayout: 'default#image',
        iconImageSize: [32, 32],
        iconImageOffset: [-16, -12],
        iconImageOffsetCluster: [-20, -20],
        iconImageFamily: 'ic_map-point-family.svg',
        iconImageFamilyHover: 'ic_map-point-family-hover.svg',
        iconImageMan: 'ic_map-point-man.svg',
        iconImageManHover: 'ic_map-point-man-hover.svg',
        iconImageCluster: 'ic_cluster.svg',
        zoomMap: 14,
        showClinic: '#show-clinic-',
        mapClinicCenter: $('[data-map-clinic-center-address="true"]'),
        closeClinic: $('[data-button-close-preview-clinic="true"]'),
        gridSize: 100,
        textSize: 40,
    });
};

/**
 * Ленивая загрузка карт
 */

$(window).on('load', function () {
    const URL_YAMAPS = "https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=40c53670-0166-47f1-9f38-9951e97a3e1c";
    //дополнительная высота, для того, чтобы карты грузились чуть раньше прокрутки до карт
    const ADDITIONAL_HEIGHT = 300;

    if ($('#map-clinics-module').length > 0) {
        let yaMapsShown = false;
        const positionTopYamaps = $('.js-map-wrapper').offset().top;
        //Проверяем, что карты не на активном экране
        if (isNeedLoadMap()) {
            yaMapsShown = true;
            loadScriptYamaps(URL_YAMAPS).then(() => {
                init();
            });
        } else {
            $(window).scroll(function() {
                if (!yaMapsShown){
                    if(isNeedLoadMap()) {
                        yaMapsShown = true;
                        loadScriptYamaps(URL_YAMAPS).then(() => {
                            init();
                        });
                    }
                }
            });
        }

        /**
         * Возвращем флаг необходимости загрузки карт
         */
        function isNeedLoadMap() {
            return ($(window).scrollTop() + $(window).height() > positionTopYamaps - ADDITIONAL_HEIGHT);
        }
    }
});

/**
 * Загрузка скриптов Яндекс Карт
 */
function loadScriptYamaps(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            reject({
                title: 'Ошибка загрузки',
                description: url
            });
        };

        script.src = url;
        document.head.appendChild(script);
    });
}
